import React, { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import User from '../../services/User'

import './styles.css'

export default () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [isSignedIn, setIsSignedIn] = useState()

    useEffect(() => {
        User.isSignedIn(setIsSignedIn)
    }, [])

    const login = (e) => {
        e.preventDefault()

        User.signIn(email, password)
            .catch(err => {
                alert('Erro ao processar requisição')
                console.log('ErrorName: ' + err.name + 'ErrorMessage: ' + err.message)
            })
    }

    if (isSignedIn === undefined) {
        return false
    } else if (isSignedIn) {
        return <Redirect to={{ pathname: '/admin' }} />
    } else {
        return (
            <div className='loginAll'>
                <form className='loginCard' onSubmit={login}>
                    <div className='loginInputWrap'>
                        <label className='loginLabel'>Email:</label>
                        <input
                            type='email'
                            className='loginInput'
                            value={email}
                            onChange={(e) => { setEmail(e.target.value) }}
                            required />
                    </div>
                    <div className='loginInputWrap'>
                        <label className='loginLabel'>Senha:</label>
                        <input
                            type='password'
                            className='loginInput'
                            value={password}
                            onChange={(e) => { setPassword(e.target.value) }}
                            required />
                    </div>
                    <button
                        type='submit'
                        className='loginButton'>Entrar</button>
                </form>
            </div>
        )
    }
}